'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ResultCtaBanner = ({
  children,
  use
}) => {
  const classes = classNames('cta-icon', {
    'trophy': 'icon-trophy',
    'mobile': 'icon-mobile',
    'lock': 'icon-locked',
    'search': 'icon-search'
  }[use]);
  return /*#__PURE__*/_jsx("div", {
    className: "result-cta-container",
    children: /*#__PURE__*/_jsxs("div", {
      className: "result-cta-banner",
      children: [/*#__PURE__*/_jsx("div", {
        className: classes
      }), /*#__PURE__*/_jsx("div", {
        className: "cta-info",
        children: children
      })]
    })
  });
};

ResultCtaBanner.propTypes = {
  children: PropTypes.node.isRequired,
  use: PropTypes.string.isRequired
};
export default ResultCtaBanner;